export const MEMBERSHIP_STATUS_LABELS = {
  PAID_MEMBER: 'Paid Member',
  NON_MEMBER: 'Non Member',
  WAITING_MEMBER: 'Waiting Member',
  INVOICED_MEMBER: 'Invoiced Member',
  CANCELLED_MEMBER: 'Cancelled Member',
  OLD_MEMBER: 'Old Member',
  OTHERS: 'Others',
}

export const MEMBERSHIP_ACTIVITY_STATUS = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
}

export const DEFAULT_VALUES = {
  NO_DATA: '-',
}

export const MIME_TYPES = {
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  OCTET_STREAM: 'application/octet-stream',
}

export const FILE_EXTENSION = {
  DEFAULT: 'bin',
}
export const COMMENTS = 'Comments'
